import { Button, Heading, Icon, Show, Spinner, Text, VStack } from '@chakra-ui/react';
import { FormattedMessage } from 'react-intl';
import { Link } from 'react-router-dom';
import { ROUTES } from 'router/routes';

export const OrderSummaryPendingView = () => (
  <VStack bg='green.G700' textAlign='center' justifyContent='center' gap='16px' p='40px 16px'>
    <Icon as={Spinner} boxSize='80px' color='yellow.500' />
    <div>
      <Heading
        as='h1'
        variant={{ base: 'headingMedium', sm: 'headingLarge' }}
        mb='4px'
        color='white'
      >
        <FormattedMessage
          id='orderSummary.pending.title'
          defaultMessage='Order is still processing'
        />
      </Heading>
      <Text textStyle='bodyLargeRegular' color='white'>
        <FormattedMessage
          id='orderSummary.pending.descriptionFirstLine'
          defaultMessage='Your order is still processing.'
        />
      </Text>
      <Show above='md'>
        <Text textStyle='bodyLargeRegular' color='white' mt='0px'>
          <FormattedMessage
            id='orderSummary.pending.descriptionSecondLine'
            defaultMessage='Please try again later'
          />
        </Text>
      </Show>
    </div>
    <Button
      variant='primaryMedium'
      bg='green.G0'
      borderColor='green.G0'
      _hover={{ bg: 'green.G200', borderColor: 'green.G200' }}
      textColor='dark.D900'
      as={Link}
      to={ROUTES.home}
    >
      <FormattedMessage id='orderSummary.pending.button' defaultMessage='Back to homepage' />
    </Button>
  </VStack>
);
